<template>
  <div class="home">
    <div class="container">
      <div class="header " :class="{ 'fix-nav': navBarFixed }">
        <div class="centre header_m">
          <img @click="toindex" :src="logo" alt="logo" />
          <div class="header_r">
            <ul>
              <router-link to="/index">
                <li :class="topIndex === 0 ? 'li_2' : 'li_1'" @click="topClick(0)">首页</li>
              </router-link>
              <router-link to="#">
                <li :class="topIndex === 9 ? 'li_2' : 'li_1'" @click="onClickYuzan()">玉瓒云校园</li>
              </router-link>
              <router-link to="/visibilization">

                <li :class="topIndex === 3 ? 'li_2' : 'li_1'" class="data" @click="topClick(3)" @mouseover="onMouseOver"
                  @mouseleave="onMouseLeave">
                  一云看板
                  <i class="el-icon-arrow-down" :class="hover ? 'icon_hover' : ''"></i>


                  <!--  -->

                  <div class="menu" v-show="hover">
                    <!-- <div class="shixin"></div> -->
                    <!-- <div class="kongxin"></div> -->

                    <ul>
                      <li>
                        产品详情
                      </li>
                      <router-link class="price" to="/visibilization/price"
                        style="color: #000; text-decoration: none !important;">

                        <li>
                          产品定价
                        </li>
                      </router-link>

                    </ul>
                    <!-- <div class="menu_item" style="color: #000;">
      产品详情
    </div>
    <div class="menu_item">
      <router-link to="/data/price" style="color: #000; text-decoration: none !important;">
        定价
      </router-link>
    </div> -->
                  </div>
                </li>
              </router-link>
              
              <router-link to="/productservice">
                <!-- <li :class="topIndex === 1 ? 'li_2' : 'li_1'" @click="topClick(1)">域贝系列产品</li> -->
                <li :class="topIndex === 1 ? 'li_2' : 'li_1'" class="data" @click="topClick(1)" @mouseover="onMouseOver2"
                  @mouseleave="onMouseLeave2">
                  域贝系列产品
                  <i class="el-icon-arrow-down" :class="hover2 ? 'icon_hover' : ''"></i>


                  <!--  -->

                  <div class="menu" v-show="hover2">
                    <ul>
                      <li>
                        域贝证书宝
                      </li>
                      <router-link class="price" to="/integrated"
                        style="color: #000; text-decoration: none !important;">
                        <li>
                          域贝一体化
                        </li>
                      </router-link>
                      <router-link class="price" to="/data"
                        style="color: #000; text-decoration: none !important;">
                        <li>
                          域贝大数据
                        </li>
                      </router-link>
                    </ul>
                  </div>
                </li>
              </router-link>
              <!-- <router-link to="/integrated">
                <li :class="topIndex === 2 ? 'li_2' : 'li_1'" @click="topClick(2)">域贝一体化</li>
              </router-link>


              <router-link to="/data">
                <li :class="topIndex === 6 ? 'li_2' : 'li_1'" @click="topClick(6)">域贝大数据</li>
              </router-link> -->
              
              <router-link to="/cooperation">
                <li :class="topIndex === 4 ? 'li_2' : 'li_1'" @click="topClick(4)">解决方案</li>
              </router-link>
              <router-link to="/about">
                <li :class="topIndex === 5 ? 'li_2' : 'li_1'" @click="topClick(5)">关于我们</li>
              </router-link>
              <li class="li_1" @click="topClick(7)" style="color: #f6412c;">400-051-0806</li>

            </ul>
          </div>
          <!-- <div style="width: 120px; color: #000; font-size: 16px; line-height: 60px;">
            400-051-0806
          </div> -->
        </div>
      </div>
      <div class="main">
        <div class="main_body">
          <router-view @event1="change($event)" @isdialogFormVisible="isdialogFormVisible" />
        </div>
      </div>
      <div class="footer" v-if="$route.meta.show">
        <div class="relation centre">
          <img class="footer_title" src="../assets/images/首页切图/底部/精致与实用本不矛盾.png" alt="" />
          <h2><i></i><i></i></h2>
          <div class="relation_l">
            <div class="relation_l_top">
              <img src="../assets/images/首页切图/底部/logo.png" alt="">
            </div>
            <h3>温州掌网信息技术有限公司</h3>
            <div style="margin-left: -13px"><i class="el-icon-location-outline"></i>浙江省温州市鹿城区车站大道11号高联大厦1608室<i
                class="el-icon-phone-outline"></i>400-051-0806</div>
            <p class="beian">备案号:浙ICP备13031672</p>
            <div class="line"></div>
          </div>
          <div class="relation_r">
            <ul>
              <li @click="() => { this.$router.push({ path: 'index' }); this.$store.commit('saveIndex', 0) }">首页</li>
              <li @click="() => { this.$router.push({ path: '/visibilization' }); this.$store.commit('saveIndex', 3) }">
                域贝可视化
              </li>
              <li @click="() => { this.$router.push({ path: 'productservice' }); this.$store.commit('saveIndex', 1) }">
                域贝电子证书</li>
              <li @click="() => { this.$router.push({ path: 'integrated' }); this.$store.commit('saveIndex', 2) }">域贝一体化
              </li>

              <li @click="() => { this.$router.push({ path: 'data' }); this.$store.commit('saveIndex', 6) }">域贝大数据</li>
              <li @click="() => { this.$router.push({ path: 'cooperation' }); this.$store.commit('saveIndex', 4) }">解决方案
              </li>
              <li @click="() => { this.$router.push({ path: 'about' }); this.$store.commit('saveIndex', 5) }">关于我们</li>
            </ul>
          </div>
          <div class="relation_logo">
            <img src="../assets/images/首页切图/底部/二维码.png" alt="">
            <p>扫描二维码<br><br>关注我们</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Counto from 'vue-count-to'

export default {
  components: { Counto },
  data() {
    return {
      startVal: 0,
      endVal1: 100,
      endVal2: 500,
      endVal3: 25,
      activeIndex: "/productservice",
      navBarFixed: false,
      isindex: true,
      dialogFormVisible: false,
      ruleForm: {
        passport: "",
        password: "",
      },
      type: "",
      formLabelWidth: "90px",
      userlist: [],
      origin: '',
      topIndex: 0,
      logo: require('../assets/images/首页切图/首图/logo.png'),
      logo1: require('../assets/images/首页切图/首图/logo.png'),
      logo2: require('../assets/images/首页切图/首图/logo2.png'),
      hover: false,
      hover2: false
    };
  },
  watch: {
    $route: {
      handler: function (val) {
      if (val.path !== '/index') {
        document.body.style.setProperty('--indexColor', '#000');
        document.body.style.setProperty('--fffcolor', '#000');
        document.body.style.setProperty('--weight', 600);
        document.body.style.setProperty('--header', 'relative');
        this.logo = this.logo2
        sessionStorage.setItem('--indexColor', '#000')
        sessionStorage.setItem('--fffcolor', '#000')
        sessionStorage.setItem('--weight', 600)
        sessionStorage.setItem('--header', 'relative')
        sessionStorage.setItem('logo', this.logo)
      } else {
        document.body.style.setProperty('--indexColor', 'rgba(255, 255, 255, 0.8)')
        document.body.style.setProperty('--fffcolor', '#fff');
        document.body.style.setProperty('--weight', 0);
        document.body.style.setProperty('--header', 'absolute');
        this.logo = this.logo1
        sessionStorage.setItem('--indexColor', 'rgba(255, 255, 255, 0.8)')
        sessionStorage.setItem('--fffcolor', '#fff')
        sessionStorage.setItem('--weight', 0)
        sessionStorage.setItem('--header', 'absolute')
        sessionStorage.setItem('logo', this.logo)
      }
    },
    immediate: true,
    },
    '$store.state.topIndex': {
      handler: function(val) {
      console.log(val)
      if (val !== 0) {
        this.topIndex = val
        sessionStorage.setItem('topIndex', val)
      }
      },
      immediate: true
    }

  },
  created() {
    // console.log(sessionStorage.getItem('topIndex'));
    // this.topIndex = sessionStorage.getItem('topIndex')
    // console.log('1111',this.topIndex,this.logo);
    // console.log('222',document.body.style.getPropertyValue('--header'));
  },
  mounted() {
    sessionStorage.getItem('topIndex') ? this.topIndex = parseInt(sessionStorage.getItem('topIndex')) : this.topIndex = 0;
    document.body.style.setProperty('--indexColor', sessionStorage.getItem('--indexColor'));
    document.body.style.setProperty('--fffcolor', sessionStorage.getItem('--fffcolor'));
    document.body.style.setProperty('--weight', parseInt(sessionStorage.getItem('--weight')));
    document.body.style.setProperty('--header', sessionStorage.getItem('--header'));
    sessionStorage.getItem('logo') ? this.logo = sessionStorage.getItem('logo') : '';

    // console.log(this.log,sessionStorage.getItem('logo'))
    // 事件监听滚动条
    window.addEventListener("scroll", this.watchScroll);
    // console.log(this.$route.path);
    let _this = this;
    this.origin = window.location.origin
    // console.log(origin)
    // 单店
    if (localStorage.getItem("passport")) {
      this.ruleForm.passport = localStorage.getItem("passport");
      this.ruleForm.password = localStorage.getItem("password");
      this.type = true;
    }
    // 集团
    // if (localStorage.getItem("passportjt")) {
    //   this.ruleForm.passport = localStorage.getItem("passportjt");
    //   this.ruleForm.password = localStorage.getItem("passwordjt");
    //   this.type = true;
    // }
    // this.$http
    //   .request({
    //     url: `/new/getLoginData`,
    //     method: "post",
    //   })
    //   .then(function (data) {
    //     _this.userlist = data.data.data.user;
    //     console.log(_this.userlist);
    //   });
  },
  destroyed() {
    // 移除事件监听
    window.removeEventListener("scroll", this.watchScroll);
  },
  methods: {
    // handleSelect(key, keyPath) {
    //   console.log(key, keyPath);
    // },

    onMouseOver() {
      this.hover = true;
    },

    onMouseLeave() {
      this.hover = false;
    },
    onMouseOver2() {
      this.hover2 = true;
    },

    onMouseLeave2() {
      this.hover2 = false;
    },
    onClickCenter() {
      window.open("http://demo.yuzanyun.com/#/")
    },
    onClickYuzan() {
      window.open("http://www.yuzanyun.com")
    },

    topClick(index) {
      this.topIndex = index
      sessionStorage.setItem('topIndex', index)
      // console.log(sessionStorage.getItem('topIndex'))
    },
    watchScroll() {
      // 滚动的距离
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;

      // 容器的高度
      var offsetTop = document.querySelector(".header").offsetHeight;

      // console.log("scrollTop=>", scrollTop, "  offsetTop=>", offsetTop);

      //  滚动的距离如果大于了元素到顶部的距离时，实现吸顶效果
      if (scrollTop > offsetTop) {
        this.navBarFixed = true;
      } else {
        this.navBarFixed = false;
      }
    },
    change(val) {
      this.activeIndex = "/cooperation";
      console.log(this.activeIndex);
      this.$router.push({
        path: "/cooperation",
      });
      // this.activeIndex = '/cooperation'
    },
    toindex() {
      this.$router.push({
        path: "/index",
      });
      this.topIndex = 0
    },
    torouter(url) {
      this.$router.push({
        path: url,
      });
    },
    closeref() {
      if (!localStorage.getItem("passport")) {
        this.$refs["ruleForm"].resetFields();
        this.type = falsey
      }
    },
    isdialogFormVisible(url) {
      this.childurl = url;
      this.dialogFormVisible = true;
    },
    login() {
      let _this = this;
      this.$refs['ruleForm'].validate((valid) => {
        if (valid) {
          this.$http
            .request({
              url: `/new/bulletLogin?passport=${this.ruleForm.passport}&password=${this.ruleForm.password}`,
              method: "post",
            })
            .then(function (data) {
              if (data.data.data) {
                _this.userlist = data.data.data.user;
                _this.dialogFormVisible = false;
                console.log(_this.userlist);
                _this.$message({
                  showClose: true,
                  message: data.data.message,
                  type: "success",
                });
                // 单店
                if (!_this.type) {
                  localStorage.removeItem("password");
                  localStorage.removeItem("passport");
                } else {
                  localStorage.setItem(
                    "password",
                    _this.ruleForm.password
                  );
                  localStorage.setItem(
                    "passport",
                    _this.ruleForm.passport
                  );
                }
                // 集团
                //  if (!_this.type) {
                //   localStorage.removeItem("passwordjt");
                //   localStorage.removeItem("passportjt");
                // } else {
                //   localStorage.setItem(
                //     "passwordjt",
                //     _this.ruleForm.password
                //   );
                //   localStorage.setItem(
                //     "passportjt",
                //     _this.ruleForm.passport
                //   );
                // }
                if (_this.childurl) {
                  _this.$router.push({
                    path: _this.childurl,
                  });
                }
              } else {
                _this.$message({
                  showClose: true,
                  message: data.data.message,
                  type: "error",
                });
              }

            });
        }
      })

    },
    quit() {
      let _this = this;
      this.$http
        .request({
          url: `/new/loginOut`,
          method: "post",
        })
        .then(function (data) {
          _this.userlist = null;
          if (_this.$route.path == '/videolist') {
            _this.$router.push({
              path: "/index",
            });
          }
          _this.$message({
            showClose: true,
            message: data.data.message,
            type: "success",
          });
        });
    },
    saoma() {
      window.location.href =
        "https://open.weixin.qq.com/connect/qrconnect?appid=wx71b2ca26582feb77&scope=snsapi_login&redirect_uri=http%3A%2F%2Fhotel.sindon.cn%2FWxLoginQRcode%2FbulletLoginbyqrcode&state=login#wechat_redirect";
    },
  },
};
</script>
<style lang="less" scoped>
li {
  list-style: none;
  text-decoration: none;
}

.router-link-active {
  text-decoration: none;
}

.data {
  position: relative;
  z-index: 999;

  .menu {
    position: absolute;
    width: 110px;
    background: #fff;
    border: 1px solid #ebeef5;
    box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    border-radius: 6px;

    .price {
      li {
        border-top: 1px solid #ebeef5;

      }
    }

    li {
      text-align: center;
      font-weight: 400;
      width: 110px;
      height: 51px;
      font-size: 14px;
      line-height: 51px;
      color: #000;
    }



    .menu_item {
      text-align: center;
      height: 40px;
      margin-top: 2px;
      line-height: 40px;
      border-radius: 6px;
      background-color: #fff;
      border: 1px solid #ebeef5;
      box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
    }
  }
}

.icon_hover {
  font-weight: 400 !important;
}

// 头部导航
.el-menu-item.is-active {
  color: #fff;
}

.centre {
  width: 1240px !important;
  margin: 0 auto;
}

.fix-nav {
  position: fixed;
  top: 0;
  z-index: 999;
  opacity: 0.9;
}

.header {
  // background-color: #b3c0d1;
  // background-image: url('../assets/images/首页切图/首图/bg1.png');
  position: var(--header);
  height: 80px;
  width: 100%;
  z-index: 9999;
}

.header_m {
  position: relative;
  color: #fff;
  height: 80px !important;
  display: flex;
  justify-content: space-between;
}

.el-icon-s-custom {
  color: #000;
  font-size: 18px;
}

.topname {
  line-height: 60px;
  font-size: 14px;
}

.quit {
  line-height: 60px;
  font-size: 14px;
  color: rgba(255, 255, 255, 0.8);
  margin-left: 10px;
  cursor: pointer;
}

.footer {
  background-image: url('../assets/images/首页切图/底部/底部bg.png');
  height: 563px !important;
  padding-top: 170px;
  padding-left: 88px;
  z-index: -111;
}

.header img {
  width: 191px;
  height: 28px;
  margin-top: 30px;
  margin-left: 20px;
}

.el-menu {}

.el-menu-item,
.el-submenu {
  height: 70px !important;
  line-height: 90px !important;
}

.el-menu.el-menu--horizontal {
  border-bottom: 0px solid #000 !important;
}

.header_r {
  display: flex;
  justify-content: space-between;
  line-height: 100px;
  margin-right: 20px;
}

.header_r ul {
  margin-right: 12px;
  margin-top: 20px;
}

.header_r ul .li_1 {
  float: left;
  list-style: none;
  display: inline-block;
  margin-left: 32px;
  height: 60px;
  color: var(--indexColor);
  line-height: 60px;
  font-size: 18px;

  // border-bottom: 3px solid #f6412c; 
  &:hover {
    color: var(--fffcolor);
    font-weight: var(--weight);
    font-size: 18px;
  }
}

// .header_r ul .li_1:hover:after {
//   color: #fff;
//   content: '';
//   width: 30px;
//   height: 10px;
//   display: block;
//   margin: 0 auto;
//   border-bottom: 3px solid #f6412c;
// }
.header_r ul .li_2 {
  float: left;
  list-style: none;
  display: inline-block;
  margin-left: 32px;
  height: 60px;
  color: var(--fffcolor);
  font-weight: var(--weight);
  // border-bottom: 3px solid #f6412c;
  line-height: 60px;
  font-size: 18px;
  // border-bottom: 3px solid #f6412c; 
}

.header_r ul .li_2::after {
  content: '';
  width: 30px;
  height: 10px;
  display: block;
  margin: -10px auto;
  border-bottom: 3px solid #f6412c;
}

.header_r {
  color: #fff;
}

.top-title h4 {
  color: #fff;
  font-size: 40px;
  font-weight: normal;
  margin-top: 341px;
  margin-left: 30px;
}

.header_btn {
  height: 40px;
  margin-top: 25px;
  margin-left: 20px;
  // background-color: #fff !important;
}

.footer {
  background-color: #031949;
  height: 452px !important;
  padding-top: 68px;
  padding-left: 88px;
  z-index: -111;
}

.relation h2 {
  text-align: center;
  font-size: 36px;
  color: #fff;
  -webkit-transform: skew(-10deg);
  /* for Chrome||Safari */
  -ms-transform: skew(-10deg);
  /* for IE */
  -moz-transform: skew(-10deg);
  /* for Firefox */
  -o-transform: skew(-10deg);
  /* for Opera */
  letter-spacing: 6px;
  margin-bottom: 59px;
}

.footer_title {
  position: relative;
  left: 430px;
}

.relation h2 i {
  font-size: 20px;
  margin: 8px 0;
}

.relation_l {
  float: left;
}

.relation_l .relation_l_top {
  height: 55px;
  width: 200px;
  // background-color: pink;
  // background-image: url('../assets/images/首页切图/首图/bg2.png');
  margin-bottom: 52px;
}

.relation_l h3 {
  font-size: 18px;
  color: #fff;
  font-weight: normal;
  margin-bottom: 20px;
}

.relation_l div {
  color: #fff;
  font-size: 14px;
  margin-bottom: 78px;
  // margin-left: -10px;
}

.relation_l div i {
  margin: 0 12px;
}

.relation_l .line {
  position: absolute;
  width: 56%;
  height: 1px;
  margin-top: -30px;
  // margin-left: 10%;
  background: #f0f0f0;
  opacity: 0.5;
}

.beian {
  font-size: 12px;
  color: #fff;
  text-decoration: none;
}

.relation_r {
  float: left;
  margin-left: 200px;
}

.relation_r ul li {
  font-size: 14px;
  color: #fff;
  margin-bottom: 15px;
  cursor: pointer;

  &:hover {
    text-decoration: underline;
  }
}

.relation_logo {
  float: left;
  margin-left: 166px;
  width: 108px;
  text-align: center;
}

.relation_logo img {
  width: 108px;
  height: 108px;
  background-color: pink;
}

.relation_logo p {
  margin-top: 20px;
  color: #fff;
  font-size: 16px;
}
</style>
